/**
 * This file contains all the codes used by the back-end
 */

import { dict } from 'src/types'

/**
 * Types
 */
export type outcome_w = 'success' | 'failure'
export type option_w = 'S' | 'N'
export type person_w = 'F' | 'G'
export type gender_w = 'F' | 'M'
export type language_w = 'IT' | 'DE'

/**
 * Sectors
 */
export const SECTORS: dict<string> = {
  '1001-1': 'car',
  '1001-2': 'atx',
  '1001-3': 'bus',
  '1001-4': 'trk',
  '1001-5': 'mop',
  '1001-6': 'crt',
  '1001-7': 'agr',
  '1001-8': 'wt1',
  '1001-9': 'wt2',
}

/**
 * Default Entities
 */
export const DEFAULT_ENTITIES: dict<string> = {
  '1001-1': '1',
  '1001-2': '3',
  '1001-3': '4',
  '1001-4': '9',
  '1001-5': '22',
  '1001-6': '25',
  '1001-7': '28',
  '1001-8': '31',
  '1001-9': '33',
}

/**
 * GAIA codes
 */
export const GAIA: dict<string> = {
  ts1a__effective_date: 'insuranceEffectiveDateOther',
  ts1a__vehicle_type_id: 'vehicleTypeId',
  ts1a__vehicle_type_tx: 'vehicleTypeText',

  // CAR
  ts2__car__vehicle_brand_id: 'vehicleMakeId',
  ts2__car__vehicle_brand_tx: 'vehicleMakeText',
  ts2__car__vehicle_model_id: 'vehicleModelId',
  ts2__car__vehicle_model_tx: 'vehicleModelText',
  ts2__car__vehicle_version_id: 'vehicleModelSpecsId',
  ts2__car__vehicle_version_tx: 'vehicleModelSpecsText',
  ts2__car__vehicle_absent: 'vehicleMakeDisabled',
  ts2__car__vehicle_displacement: 'vehicleCC',
  ts2__car__vehicle_power: 'vehiclePower',
  ts2__car__vehicle_power_supply_id: 'vehicleFuelId',
  ts2__car__vehicle_power_supply_tx: 'vehicleFuelText',
  ts2__car__use_type: 'useType',
  ts2__car__other_use_types_id: 'otherUsesId',
  ts2__car__other_use_types_tx: 'otherUsesText',
  ts2__car__towbar_id: 'vehicleTowbarId',
  ts2__car__towbar_tx: 'vehicleTowbarText',
  ts2__car__residence_province_id: 'Sigla Provincia',
  ts2__car__residence_province_tx: 'Sigla Provinciatext',
  ts2__car__residence_municipality_id: 'contractorCommuneId',
  ts2__car__residence_municipality_tx: 'contractorCommuneText',
  ts2__car__registration_date: 'vehicleImmatricolazioneDate',
  ts2__car__purchase_date: 'Data Di Acquisto',
  ts2__car__years_possession: 'Anni Possesso',
  ts3__car__contractual_form_id: 'insuranceContractId',
  ts3__car__contractual_form_tx: 'insuranceContractText',
  ts3__car__fractionation_id: 'frazionamentoId',
  ts3__car__fractionation_tx: 'frazionamentoText',
  ts3__car__maximum_compensation_id: 'massimaleId',
  ts3__car__maximum_compensation_tx: 'massimale',
  ts3__car__insurance_situation_id: 'insuranceSituationId',
  ts3__car__insurance_situation_tx: 'insuranceSituationText',
  ts3__car__origin_company_id: 'insuranceCompanyId',
  ts3__car__origin_company_tx: 'insuranceCompanyText',
  ts3__car__itas_class: 'insuranceClassItas',
  ts3__car__certificate_contractual_form_id: 'insuranceContractAttId',
  ts3__car__certificate_contractual_form_tx: 'insuranceContractAttText',
  ts3__car__certificate_expiration_date: 'insuranceExpiryDate',
  ts3__car__cu_assignment_class: 'insuranceClassCU',
  ts3__car__year_1: 'claims-year1',
  ts3__car__year_2: 'claims-year2',
  ts3__car__year_3: 'claims-year3',
  ts3__car__year_4: 'claims-year4',
  ts3__car__year_5: 'claims-year5',
  ts3__car__year_6: 'claims-year6',
  ts3__car__year_7: 'claims-year7',
  ts3__car__year_8: 'claims-year8',
  ts3__car__year_9: 'claims-year9',
  ts3__car__year_10: 'claims-year10',
  ts3__car__year_11: 'claims-year11',
  ts4__car__protected_bonus_id: 'clausola5id',
  ts4__car__protected_bonus_tx: 'clausola-5',
  ts4__car__expert_guide_id: 'clausola4id',
  ts4__car__expert_guide_tx: 'clausola-4',
  ts4__trk__expert_guide_id: 'clausola4id',
  ts4__trk__expert_guide_tx: 'clausola-4',
  ts4__mop__expert_guide_id: 'clausola4id',
  ts4__mop__expert_guide_tx: 'clausola-4',
  ts5__car__owner_id: 'contractorOwnerId',
  ts5__car__owner_tx: 'contractorOwnerText',
  ts5__car__birth_date: 'contractorBirthDate',
  ts5__car__driving_license_years: 'contractorPatenteDate',
  ts5__car__cap: 'contractorResidenzaText',
  ts5__car__special_driving_license_id: 'clausola1id',
  ts5__car__special_driving_license_tx: 'clausola-1',
  ts2__car__residence_cap_id: 'contractorCap',
  ts2__car__residence_cap_tx: 'contractorCapText',

  // ATX
  ts2__atx__entity_id: 'nomeEntitaId',
  ts2__atx__entity_tx: 'nomeEntita',
  ts2__atx__category_id_0: 'codCate',
  ts2__atx__category_id_1: 'codClss',
  ts2__atx__category_id_2: 'codSpcz',
  ts2__atx__category_id_3: 'codSttr',
  ts2__atx__category_tx: 'categoria',
  ts2__atx__fractionation_id: 'frazionamentoId',
  ts2__atx__fractionation_tx: 'frazionamentoText',
  ts2__atx__contractual_form_id: 'formaContr',
  ts2__atx__contractual_form_tx: 'descFormaFc',
  ts2__atx__province_id: 'Sigla Provincia',
  ts2__atx__province_tx: 'Sigla Provinciatext',
  ts2__atx__pra_municipality_id: 'Comune Pra',
  ts2__atx__pra_municipality_tx: 'Comune Pratext',
  ts2__atx__vehicle_displacement_id: 'Cilindrata',
  ts2__atx__vehicle_displacement_tx: 'Cilindratatext',
  ts2__atx__vehicle_power: 'Potenza Kw',
  ts2__atx__vehicle_power_id: 'Potenza Kw',
  ts2__atx__vehicle_power_tx: 'Potenza Kwtext',
  ts2__atx__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__atx__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__atx__towbar_id: 'Traino',
  ts2__atx__towbar_tx: 'Trainotext',
  ts2__atx__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__atx__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__atx__first_matriculation: 'Prima Immatricolazione',
  ts2__atx__purchase_date: 'Data Di Acquisto',
  ts2__atx__years_possession: 'Anni Possesso',
  ts3__atx__insurance_situation_id: 'insuranceSituationId',
  ts3__atx__insurance_situation_tx: 'insuranceSituationText',
  ts3__atx__origin_company_id: 'insuranceCompanyId',
  ts3__atx__origin_company_tx: 'insuranceCompanyText',
  ts3__atx__certificate_contractual_form_id: 'insuranceContractAttId',
  ts3__atx__certificate_contractual_form_tx: 'insuranceContractAttText',
  ts3__atx__certificate_expiration_date: 'insuranceExpiryDate',
  ts3__atx__cu_assignment_class: 'insuranceClassCU',
  ts3__atx__year_1: 'claims-year1',
  ts3__atx__year_2: 'claims-year2',
  ts3__atx__year_3: 'claims-year3',
  ts3__atx__year_4: 'claims-year4',
  ts3__atx__year_5: 'claims-year5',
  ts3__atx__year_6: 'claims-year6',
  ts3__atx__year_7: 'claims-year7',
  ts3__atx__year_8: 'claims-year8',
  ts3__atx__year_9: 'claims-year9',
  ts3__atx__year_10: 'claims-year10',
  ts3__atx__year_11: 'claims-year11',
  ts5__atx__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__atx__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__atx__birth_date: 'Data Nascita',
  ts5__atx__driving_license_years: 'Anni Patente',
  ts5__atx__cap: 'contractorResidenzaText',

  // BUS
  ts2__bus__entity_id: 'nomeEntitaId',
  ts2__bus__entity_tx: 'nomeEntita',
  ts2__bus__category_id_0: 'codCate',
  ts2__bus__category_id_1: 'codClss',
  ts2__bus__category_id_2: 'codSpcz',
  ts2__bus__category_id_3: 'codSttr',
  ts2__bus__category_tx: 'categoria',
  ts2__bus__fractionation_id: 'frazionamentoId',
  ts2__bus__fractionation_tx: 'frazionamentoText',
  ts2__bus__contractual_form_id: 'formaContr',
  ts2__bus__contractual_form_tx: 'descFormaFc',
  ts2__bus__province_id: 'Sigla Provincia',
  ts2__bus__province_tx: 'Sigla Provinciatext',
  ts2__bus__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__bus__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__bus__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__bus__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__bus__seats_number_id: 'Posti',
  ts2__bus__seats_number_tx: 'Postitext',
  ts2__bus__franchise_id: 'Valore Franchigia',
  ts2__bus__franchise_tx: 'Valore Franchigiatext',
  ts5__bus__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__bus__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__bus__birth_date: 'contractorBirthDate',
  ts5__bus__cap: 'contractorResidenzaText',

  // TRK
  ts2__trk__entity_id: 'nomeEntitaId',
  ts2__trk__entity_tx: 'nomeEntita',
  ts2__trk__category_id_0: 'codCate',
  ts2__trk__category_id_1: 'codClss',
  ts2__trk__category_id_2: 'codSpcz',
  ts2__trk__category_id_3: 'codSttr',
  ts2__trk__category_tx: 'categoria',
  ts2__trk__fractionation_id: 'frazionamentoId',
  ts2__trk__fractionation_tx: 'frazionamentoText',
  ts2__trk__contractual_form_id: 'formaContr',
  ts2__trk__contractual_form_tx: 'descFormaFc',
  ts2__trk__province_id: 'Sigla Provincia',
  ts2__trk__province_tx: 'Sigla Provinciatext',
  ts2__trk__pra_municipality_id: 'Comune Pra',
  ts2__trk__pra_municipality_tx: 'Comune Pratext',
  ts2__trk__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__trk__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__trk__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__trk__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__trk__goods_type_id: 'Tipo Merce Trasportata',
  ts2__trk__goods_type_tx: 'Tipo Merce Trasportatatext',
  ts2__trk__quintals_id: 'Quintali',
  ts2__trk__quintals_tx: 'Quintalitext',
  ts2__trk__quintals_trailer_id: 'Quintali Rimorchio',
  ts2__trk__quintals_trailer_tx: 'Quintali Rimorchiotext',
  ts2__trk__transported_id: 'Trasportati',
  ts2__trk__transported_tx: 'Trasportatitext',
  ts2__trk__vehicle_displacement_id: 'Cilindrata',
  ts2__trk__vehicle_displacement_tx: 'Cilindratatext',
  ts2__trk__franchise_id: 'Valore Franchigia',
  ts2__trk__franchise_tx: 'Valore Franchigiatext',
  ts2__trk__first_matriculation: 'Prima Immatricolazione',
  ts3__trk__insurance_situation_id: 'insuranceSituationId',
  ts3__trk__insurance_situation_tx: 'insuranceSituationText',
  ts3__trk__origin_company_id: 'insuranceCompanyId',
  ts3__trk__origin_company_tx: 'insuranceCompanyText',
  ts3__trk__itas_class: 'insuranceClassItas',
  ts3__trk__certificate_contractual_form_id: 'insuranceContractAttId',
  ts3__trk__certificate_contractual_form_tx: 'insuranceContractAttText',
  ts3__trk__certificate_expiration_date: 'insuranceExpiryDate',
  ts3__trk__cu_assignment_class: 'insuranceClassCU',
  ts3__trk__year_1: 'claims-year1',
  ts3__trk__year_2: 'claims-year2',
  ts3__trk__year_3: 'claims-year3',
  ts3__trk__year_4: 'claims-year4',
  ts3__trk__year_5: 'claims-year5',
  ts3__trk__year_6: 'claims-year6',
  ts3__trk__year_7: 'claims-year7',
  ts3__trk__year_8: 'claims-year8',
  ts3__trk__year_9: 'claims-year9',
  ts3__trk__year_10: 'claims-year10',
  ts3__trk__year_11: 'claims-year11',
  ts5__trk__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__trk__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__trk__birth_date: 'Data Nascita',
  ts5__trk__cap: 'contractorResidenzaText',

  // MOP
  ts2__mop__entity_id: 'nomeEntitaId',
  ts2__mop__entity_tx: 'nomeEntita',
  ts2__mop__category_id_0: 'codCate',
  ts2__mop__category_id_1: 'codClss',
  ts2__mop__category_id_2: 'codSpcz',
  ts2__mop__category_id_3: 'codSttr',
  ts2__mop__category_tx: 'categoria',
  ts2__mop__fractionation_id: 'frazionamentoId',
  ts2__mop__fractionation_tx: 'frazionamentoText',
  ts2__mop__contractual_form_id: 'formaContr',
  ts2__mop__contractual_form_tx: 'descFormaFc',
  ts2__mop__transported_id: 'Trasportati',
  ts2__mop__transported_tx: 'Trasportatitext',
  ts2__mop__towbar_id: 'Traino',
  ts2__mop__towbar_tx: 'Trainotext',
  ts2__mop__province_id: 'Sigla Provincia',
  ts2__mop__province_tx: 'Sigla Provinciatext',
  ts2__mop__pra_municipality_id: 'Comune Pra',
  ts2__mop__pra_municipality_tx: 'Comune Pratext',
  ts2__mop__vehicle_displacement_id: 'Cilindrata',
  ts2__mop__vehicle_displacement_tx: 'Cilindratatext',
  ts2__mop__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__mop__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__mop__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__mop__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__mop__franchise_id: 'Valore Franchigia',
  ts2__mop__franchise_tx: 'Valore Franchigiatext',
  ts2__mop__first_matriculation: 'Prima Immatricolazione',
  ts2__mop__4__ruote_id: 'CODICE MARCA 4R',
  ts2__mop__4__ruote_tx: 'CODICE MARCA4RText',
  ts2__mop__2__ruote_id: 'CODICE MARCA 2R',
  ts2__mop__2__ruote_tx: 'CODICE MARCA2RText',
  ts2__mop__carrozzerie__type_id: 'Tipo Carrozzeria',
  ts2__mop__carrozzerie__type_tx: 'Tipo CarrozzeriaText',
  ts2__mop__vehicle__type_id: 'Tipologia Veicolo',
  ts2__mop__vehicle__type_tx: 'Tipologia VeicoloText',
  ts3__mop__insurance_situation_id: 'insuranceSituationId',
  ts3__mop__insurance_situation_tx: 'insuranceSituationText',
  ts3__mop__origin_company_id: 'insuranceCompanyId',
  ts3__mop__origin_company_tx: 'insuranceCompanyText',
  ts3__mop__itas_class: 'insuranceClassItas',
  ts3__mop__certificate_contractual_form_id: 'insuranceContractAttId',
  ts3__mop__certificate_contractual_form_tx: 'insuranceContractAttText',
  ts3__mop__certificate_expiration_date: 'insuranceExpiryDate',
  ts3__mop__cu_assignment_class: 'insuranceClassCU',
  ts3__mop__year_1: 'claims-year1',
  ts3__mop__year_2: 'claims-year2',
  ts3__mop__year_3: 'claims-year3',
  ts3__mop__year_4: 'claims-year4',
  ts3__mop__year_5: 'claims-year5',
  ts3__mop__year_6: 'claims-year6',
  ts3__mop__year_7: 'claims-year7',
  ts3__mop__year_8: 'claims-year8',
  ts3__mop__year_9: 'claims-year9',
  ts3__mop__year_10: 'claims-year10',
  ts3__mop__year_11: 'claims-year11',
  ts5__mop__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__mop__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__mop__birth_date: 'Data Nascita',
  ts5__mop__cap: 'contractorResidenzaText',

  // CRT
  ts2__crt__entity_id: 'nomeEntitaId',
  ts2__crt__entity_tx: 'nomeEntita',
  ts2__crt__category_id_0: 'codCate',
  ts2__crt__category_id_1: 'codClss',
  ts2__crt__category_id_2: 'codSpcz',
  ts2__crt__category_id_3: 'codSttr',
  ts2__crt__category_tx: 'categoria',
  ts2__crt__fractionation_id: 'frazionamentoId',
  ts2__crt__fractionation_tx: 'frazionamentoText',
  ts2__crt__contractual_form_id: 'formaContr',
  ts2__crt__contractual_form_tx: 'descFormaFc',
  ts2__crt__province_id: 'Sigla Provincia',
  ts2__crt__province_tx: 'Sigla Provinciatext',
  ts2__crt__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__crt__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__crt__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__crt__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__crt__quintals_id: 'Quintali',
  ts2__crt__quintals_tx: 'Quintalitext',
  ts2__crt__tracks_id: 'Cingoli',
  ts2__crt__tracks_tx: 'Cingolitext',
  ts5__ctr__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__ctr__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__ctr__birth_date: 'contractorBirthDate',
  ts5__crt__cap: 'contractorResidenzaText',

  // AGR
  ts2__agr__entity_id: 'nomeEntitaId',
  ts2__agr__entity_tx: 'nomeEntita',
  ts2__agr__category_id_0: 'codCate',
  ts2__agr__category_id_1: 'codClss',
  ts2__agr__category_id_2: 'codSpcz',
  ts2__agr__category_id_3: 'codSttr',
  ts2__agr__category_tx: 'categoria',
  ts2__agr__fractionation_id: 'frazionamentoId',
  ts2__agr__fractionation_tx: 'frazionamentoText',
  ts2__agr__contractual_form_id: 'formaContr',
  ts2__agr__contractual_form_tx: 'descFormaFc',
  ts2__agr__province_id: 'Sigla Provincia',
  ts2__agr__province_tx: 'Sigla Provinciatext',
  ts2__agr__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__agr__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__agr__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__agr__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts5__agr__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__agr__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__agr__birth_date: 'contractorBirthDate',
  ts5__agr__cap: 'contractorResidenzaText',

  // WT1
  ts2__wt1__entity_id: 'nomeEntitaId',
  ts2__wt1__entity_tx: 'nomeEntita',
  ts2__wt1__category_id_0: 'codCate',
  ts2__wt1__category_id_1: 'codClss',
  ts2__wt1__category_id_2: 'codSpcz',
  ts2__wt1__category_id_3: 'codSttr',
  ts2__wt1__category_tx: 'categoria',
  ts2__wt1__fractionation_id: 'frazionamentoId',
  ts2__wt1__fractionation_tx: 'frazionamentoText',
  ts2__wt1__contractual_form_id: 'formaContr',
  ts2__wt1__contractual_form_tx: 'descFormaFc',
  ts2__wt1__province_id: 'Sigla Provincia',
  ts2__wt1__province_tx: 'Sigla Provinciatext',
  ts2__wt1__vehicle_power_supply_id: 'Tipo Alimentazione',
  ts2__wt1__vehicle_power_supply_tx: 'Tipo Alimentazionetext',
  ts2__wt1__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__wt1__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__wt1__vehicle_displacement_id: 'Cilindrata',
  ts2__wt1__vehicle_displacement_tx: 'Cilindratatext',
  ts2__wt1__vehicle_kw_power_id: 'Potenza Kw',
  ts2__wt1__vehicle_kw_power_tx: 'Potenza Kwtext',
  ts2__wt1__hull_length_id: 'Lunghezza In Metri F.t.',
  ts2__wt1__hull_length_tx: 'Lunghezza In Metri F.t.text',
  ts2__wt1__hydrosciatory_activity_id: "Attivita' Idrosciatoria",
  ts2__wt1__hydrosciatory_activity_tx: "Attivita' Idrosciatoriatext",
  ts2__wt1__rca1_id: 'Rca - Condizione Aggiuntiva L-estensione Dei Limiti Di Navigazione',
  ts2__wt1__rca1_tx: 'Rca - Condizione Aggiuntiva L-estensione Dei Limiti Di Navigazionetext',
  ts2__wt1__rca2_id: 'Rca - Condizione Aggiuntiva M-regate Veliche',
  ts2__wt1__rca2_tx: 'Rca - Condizione Aggiuntiva M-regate Velichetext',
  ts5__wt1__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__wt1__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__wt1__birth_date: 'contractorBirthDate',
  ts5__wt1__cap: 'contractorResidenzaText',

  // WT2
  ts2__wt2__entity_id: 'nomeEntitaId',
  ts2__wt2__entity_tx: 'nomeEntita',
  ts2__wt2__category_id_0: 'codCate',
  ts2__wt2__category_id_1: 'codClss',
  ts2__wt2__category_id_2: 'codSpcz',
  ts2__wt2__category_id_3: 'codSttr',
  ts2__wt2__category_tx: 'categoria',
  ts2__wt2__fractionation_id: 'frazionamentoId',
  ts2__wt2__fractionation_tx: 'frazionamentoText',
  ts2__wt2__contractual_form_id: 'formaContr',
  ts2__wt2__contractual_form_tx: 'descFormaFc',
  ts2__wt2__province_id: 'Sigla Provincia',
  ts2__wt2__province_tx: 'Sigla Provinciatext',
  ts2__wt2__maximum_per_claim_id: 'Massimale Per Sinistro',
  ts2__wt2__maximum_per_claim_tx: 'Massimale Per Sinistrotext',
  ts2__wt2__vehicle_displacement_id: 'Cilindrata',
  ts2__wt2__vehicle_displacement_tx: 'Cilindratatext',
  ts2__wt2__gross_tonnage: 'Tonnellate Stazza Lorda',
  ts2__wt2__seats_number: 'Posti',
  ts5__wt2__owner_id: 'Tipo Persona F=fisica G=giuridica',
  ts5__wt2__owner_tx: 'Tipo Persona F=fisica G=giuridicatext',
  ts5__wt2__birth_date: 'contractorBirthDate',
  ts5__wt2__cap: 'contractorResidenzaText',
}
